import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import './../../assets/styles/constants.css';
import './../../assets/styles/fonts.css';
import './Count.css';

const Count = ({
  count,
  unitSingular,
  unitPlural,
  isFormattedNumber,
  isAllCaps,
  customFormat
}) => {
  const unitLabel = count === 1 ? unitSingular : unitPlural;
  const formattedCount =
    isFormattedNumber && count !== 1 && count !== 0
      ? numeral(count).format(customFormat)
      : count;
  const displayCount = isAllCaps
    ? `${formattedCount} ${unitLabel}`.toUpperCase()
    : `${formattedCount} ${unitLabel}`;
  return <div className="tvt-count">{displayCount}</div>;
};

Count.propTypes = {
  count: PropTypes.number.isRequired,
  unitSingular: PropTypes.string.isRequired,
  unitPlural: PropTypes.string.isRequired,
  isFormattedNumber: PropTypes.bool,
  isAllCaps: PropTypes.bool,
  customFormat: PropTypes.string
};

Count.defaultProps = {
  isFormattedNumber: true,
  isAllCaps: true,
  customFormat: '0.0a'
};

export default Count;
